// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoImage_image__VC4o5","forGenericHeader":"LogoImage_forGenericHeader__Pv9i4","forPackageHeader":"LogoImage_forPackageHeader__fL4kH"};